import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./global.css";
import App from "./App.jsx";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import * as Sentry from "@sentry/react";
import { Capacitor } from "@capacitor/core";

const platform = Capacitor.getPlatform();


if (import.meta.env.VITE_MODE != "development" || platform !== "web") {
  Sentry.init({
    dsn: "https://25852226e1674bf2c22a38369084aa0c@o4509047144972288.ingest.us.sentry.io/4509047146479616",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", "app.billzpay.com.ng", "v2.billzpay.com.ng"],
    // Session Replay
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0
  });
}


const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

const root = createRoot(rootElement);
const Router = platform === 'web' ? BrowserRouter : HashRouter;
root.render(
  <StrictMode>
    <HelmetProvider>
      <Router>
        <App />
      </Router>
    </HelmetProvider>
  </StrictMode>,
);
